import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';

import Arrow from 'icons/DropdownArrow';

import Media from 'css/Media';

export class AccordionModule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null
        }
    }

    handleClick = idx => {
        if(this.state.activeIndex === idx) {
            this.setState({activeIndex: null})
        } else this.setState({activeIndex: idx})
    }

    render() {
        const { activeIndex } = this.state;
        const { data, last } = this.props;
        return (
            <Wrapper last={last}>
                <Container grid numRows={data.sections.length}>
                    <StyledGridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                        <StyledH2>{data.headline}</StyledH2>
                        <Accordion allowZeroExpanded={true}>
                            {data.sections.map((section, idx) => {
                                return (
                                    <StyledAccordionItem key={idx}>
                                            <AccordionItemHeading>
                                                <StyledAccordionItemButton>
                                                    <SectionWrapper onClick={() => this.handleClick(idx)} open={activeIndex === idx}>
                                                        <h5>{section.title}</h5>
                                                        <Arrow />
                                                    </SectionWrapper>
                                                </StyledAccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <StyledHtml content>{section.content}</StyledHtml>
                                            </AccordionItemPanel>
                                    </StyledAccordionItem>
                                )
                            })}
                        </Accordion>
                    </StyledGridElement>
                </Container>
            </Wrapper>
        )
    }
}

export default AccordionModule;

const Wrapper = styled.section`
    padding: ${props => props.last ? `${props.theme.spacing.elementXS} 0 0` : `${props.theme.spacing.elementXS} 0 `};
    

    ${Media.greaterThan('s')`
        padding: ${props => props.last ? `${props.theme.spacing.blockM} 0 0` : `${props.theme.spacing.blockM} 0 `};
    `}
`

const StyledH2 = styled.h2`
    position: absolute;
    bottom: 120px;
`;

const SectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${props => props.theme.spacing.contentS} 0;
    cursor: pointer;
    
    h5 {
        transition: all .2s ease-in;
        color: ${props => props.theme.colors.text};
    }

    svg {
        transition: all .2s ease-in;
        transform: rotate(180deg);
        width: 16px;
        height: 8px;
        
        path {
            transition: all .2s ease-in;
            stroke: ${props => props.theme.colors.text};
        }
    }

    ${props => props.open && css`
        svg {
            transform: rotate(360deg);
        }
    `}

    &:hover {
        h5 {
            color: ${props => props.theme.colors.link};
        }

        svg {
            path {
                stroke: ${props => props.theme.colors.link};
            }
        }
    }

    ${Media.greaterThan('s')`
        padding: ${props => props.theme.spacing.contentL} 0;
    `}
`

const StyledGridElement = styled(GridElement)`
    border-top: 1px solid ${props => props.theme.colors.lines};
`

const StyledHtml = styled(Html)`
    padding-bottom: ${props => props.theme.spacing.contentS};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentL};
    `}
`

const StyledAccordionItem = styled(AccordionItem)`
    border-bottom: 1px solid ${props => props.theme.colors.lines};
`

const StyledAccordionItemButton = styled(AccordionItemButton)`
    &:hover,
    &:focus,
    &:focus-within,
    &:active {
        outline: none;
    }
`